// extracted by mini-css-extract-plugin
export default {"PollForm":"styles_PollForm__q6ddA"};